import { Component, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Router } from "@angular/router";
import { NGXLogger } from "ngx-logger";

@Component({
    selector: 'refund-req-res-dialog',
    template: `
    <h1 mat-dialog-title>{{dialogTitle}}</h1>

    <div mat-dialog-content style="margin-top: 30px; margin-bottom: 30px; margin-left: 0px;">
        <h4>{{message}}</h4>
    </div>

    <div mat-dialog-actions>
        <button mat-button type="button" style="background-color: #FFA728;" cdkFocusInitial (click)="close()" tabindex="-1">Close</button>
    </div>
    `,
  })
  export class RefundReqResDialog {

    message: string;
    dialogTitle: string;

    constructor(
        public dialogRef: MatDialogRef<RefundReqResDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private logger: NGXLogger,
        private dialog: MatDialog,
        private router: Router) { }

    ngOnInit() {
     this.message = this.data.message;
     this.dialogTitle = this.data.dialogTitle;
    }

    close(): void {
      //this.logger.debug("Bkash refund request response dialog closed");
      this.dialogRef.close(true);
    }
  }



// WEBPACK FOOTER //
// ./src/app/report/pg-detailed-transaction-report/refund-req-res-dialog.component.ts